var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-wrapper",style:({
    color: _vm.isReady ? 'white' : 'transparent',
    backgroundColor: 'rgba(0, 0, 0, 0.3)'
  })},[_c('h1',{ref:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{ref:"description"},[_vm._v(" "+_vm._s(_vm.description)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }